/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { Map } from 'immutable';
import errors from '../../config/errors';

import {
  APP_ERROR,
  APP_SUCCESS,
  APP_LOADING,
  SET_USER,
  INIT_APP_COMPLETE,
  SET_HISTORY,
  SET_UPCOMING_VISIT,
  SET_CURRENT_VISIT,
  SET_ACTIVE_VISIT,
  SET_ACTIVE_REPORT,
  SORT_ACTIVE_REPORTS,
  CHECK_IF_MOBILE,
  SET_ACTIVE_ASSESSMENTS,
  SET_ACTIVE_ASSESSMENT,
  SET_PROGRESS_BAR_PERCENT,
  SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE,
  SET_SORTED_ASSESSMENTS,
  LOGOUT
} from './action-types';

const defaultState = {
  user: null,
  history: null,
  upcomingVisit: null,
  currentVisit: null,
  activeVisit: null,
  activeReports: null,
  activeAssessments: null,
  sortedAssessments: null,
  activeAssessment: null,
  activeReport: null,
  data: null,
  error: errors.basic,
  isLoading: null,
  isSuccess: null,
  hasError: null,
  isInit: true,
  isMobile: false,
  progressBarPercent: 0,
  isUpcomingVisitAssessmentsNotice: false
};

const initialState = Map(defaultState);

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isSuccess', true)
        .set('hasError', false)
        .set('data', action.payload)
        .set('error', errors.basic);
    case APP_ERROR:
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', true)
        .set('error', action.error);
    case APP_LOADING:
      return state
        .set('isLoading', true)
        .set('isSuccess', false)
        .set('hasError', false)
        .set('error', errors.basic);
    case SET_USER:
      return state.set('user', action.payload);
    case SET_HISTORY:
      return state.set('history', action.payload);
    case SET_UPCOMING_VISIT:
      return state.set('upcomingVisit', action.payload);
    case SET_CURRENT_VISIT:
      return state.set('currentVisit', action.payload);
    case SET_ACTIVE_VISIT:
      return state.set('activeVisit', action.payload);
    case INIT_APP_COMPLETE:
      return state.set('isInit', true).set('hasError', false);
    case CHECK_IF_MOBILE:
      return state.set('isMobile', action.payload);
    case SORT_ACTIVE_REPORTS:
      return state.set('activeReports', action.payload);
    case SET_ACTIVE_REPORT:
      return state.set('activeReport', action.payload);
    case SET_ACTIVE_ASSESSMENTS:
      return state.set('activeAssessments', { ...action.payload });
    case 'SET_SURVEY_LAST_COMPLETED_DATE':
      return state.set('surveysLastCompletedAt', action.payload);
    case 'SET_SURVEY_LAST_MODIFIED_DATE':
      return state.set('surveysLastModifiedOn', action.payload);
    case 'SET_SURVEY_LAST_UPDATED_DATE':
      return state.set('surveysLastUpdatedAt', action.payload);
    case SET_SORTED_ASSESSMENTS:
      return state.set('sortedAssessments', action.payload);
    case SET_ACTIVE_ASSESSMENT:
      return state.set('activeAssessment', action.payload);
    case SET_PROGRESS_BAR_PERCENT:
      return state.set('progressBarPercent', action.payload);
    case SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE:
      return state.set('isUpcomingVisitAssessmentsNotice', action.payload);
    case LOGOUT:
      return Map(defaultState);
    default:
      return state;
  }
};

export default appReducer;
